 document.addEventListener('DOMContentLoaded', function () {
    const sizeGuideLink = document.getElementById('ctm-size-chart-popup');
    const modal = document.getElementById('ctm-size-chart-modal');
    const modalImg = document.getElementById('ctm-size-chart-img');
    const closeBtn = document.querySelector('.ctm-close-modal');

    if (sizeGuideLink && modal && modalImg) {
      sizeGuideLink.addEventListener('click', function(e) {
        e.preventDefault();
        const imageUrl = this.getAttribute('data-size-chart');
        if (imageUrl) {
          modalImg.src = imageUrl;
          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';
          setTimeout(() => {
            modal.classList.add('show');
          }, 10);
        }
      });

      closeBtn.addEventListener('click', function() {
        modal.classList.remove('show');
        document.body.style.overflow = '';
        setTimeout(() => {
          modal.style.display = 'none';
        }, 300);
      });

      window.addEventListener('click', function(e) {
        if (e.target === modal) {
          modal.classList.remove('show');
          document.body.style.overflow = '';
          setTimeout(() => {
            modal.style.display = 'none';
          }, 300);
        }
      });
    }
  });